import React from 'react';

import { getCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils';
import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { usePageContentId } from '@confluence/page-context';
import { COMPANY_HUB_EDIT } from '@confluence/named-routes';

import { navdexEnd } from '../naxdev';
import { EditPageOrBlogV2Route } from './EditPageOrBlogV2Route';

export const CompanyHubEditRoute = ({ query }) => {
	const spaceKey = getCompanyHubSpaceKey() ?? '';
	const [contentId] = usePageContentId();

	return (
		<EditPageOrBlogV2Route
			params={{ contentId: contentId ?? '', spaceKey, contentType: 'pages' }}
			name={COMPANY_HUB_EDIT.name}
			search=""
			hash=""
			pathname={COMPANY_HUB_EDIT.pattern}
			pattern={COMPANY_HUB_EDIT.pattern}
			url={COMPANY_HUB_EDIT.toUrl()}
			query={query}
		/>
	);
};

CompanyHubEditRoute.NAVIGATION_PARAMS = () => {
	const spaceKey = getCompanyHubSpaceKey() ?? '';
	// TODO: query contentId value instead of passing an empty string
	const contentId = '';

	return {
		Screen: {
			screenEvent: {
				name: COMPANY_HUB_EDIT.name,
				id: contentId,
				...navdexEnd,
			},
			pageState: { contentId, spaceKey },
		},
		MainLayout: {
			navView: PRODUCT_HOME_ID,
		},
	};
};
